import Category from './category';
import DropdownInternal from './dropdown-internal';
import Item from './item';
const DropdownNamespace = Object.assign(DropdownInternal, {
    Category,
    Item,
});
export default DropdownNamespace;
